import React, { useState, useMemo, useEffect, useRef } from 'react';

export const AccordionPanel = (props) => props;

// onToggle is optional and is called with the index of the open panel, or -1 when all are closed.
// closeOnClickOutside is optional and closes the open panel when clicking outside the accordion.
// isClickInside is optional: (target) => boolean, lets the parent treat clicks on related
// elements rendered outside the accordion (e.g. selected filter tags) as inside clicks.
export const Accordion = ({
    children,
    className,
    onToggle,
    closeOnClickOutside,
    isClickInside,
}) => {
    const [index, setIndex] = useState(-1);
    const containerRef = useRef(null);

    const setActiveIndex = (nextIndex) => {
        setIndex(nextIndex);
        onToggle && onToggle(nextIndex);
    };

    const handleClickHeader = (clickedIndex) => {
        setActiveIndex(index === clickedIndex ? -1 : clickedIndex);
    };

    useEffect(() => {
        if (!closeOnClickOutside || index === -1) {
            return undefined;
        }

        const closeOnOutsideClick = (event) => {
            const inside =
                (containerRef.current &&
                    containerRef.current.contains(event.target)) ||
                (isClickInside && isClickInside(event.target));
            if (!inside) {
                setActiveIndex(-1);
            }
        };

        document.addEventListener('click', closeOnOutsideClick);

        return () => document.removeEventListener('click', closeOnOutsideClick);
    }, [closeOnClickOutside, index, isClickInside]);

    const activeClass = (itemIndex) => (itemIndex === index ? 'active' : '');

    const accordions = useMemo(() => React.Children.toArray(children), [
        children,
    ]);

    const headers = accordions.map((accordion, index) => (
        <div className="columns" key={`accordion__header-${index}`}>
            <div
                className={`accordion__header ${activeClass(index)} ${
                    accordion.props.icon || ''
                }`}
                onClick={() => handleClickHeader(index)}
            >
                {accordion.props.header || ''}
            </div>
        </div>
    ));

    const panels = accordions.map((accordion, index) => (
        <div
            className={`accordion__panel ${activeClass(index)}`}
            key={`accordion__panel-${index}`}
        >
            {accordion.props.children}
        </div>
    ));

    return (
        <div className={className} ref={containerRef}>
            <nav className={`accordion__header-container`}>{headers}</nav>
            {panels}
        </div>
    );
};
